import React from 'react';
import { Listing } from '../types';
import { ago, facts, isNew, money, sourcesLabel } from '../format';

type Props = {
  listing: Listing;
  onOpen: (listing: Listing) => void;
};

export function ListingPhoto({ listing, showNew }: { listing: Listing; showNew: boolean }) {
  return (
    <div className="ma-photo">
      {listing.primaryImage ? <img src={listing.primaryImage} alt="" loading="lazy" /> : <span>No photo</span>}
      {showNew && <span className="ma-badge">New</span>}
    </div>
  );
}

export default function ListingCard({ listing, onOpen }: Props) {
  return (
    <button type="button" className="ma-listing" onClick={() => onOpen(listing)}>
      <ListingPhoto listing={listing} showNew={isNew(listing.publishedAt)} />
      <div className="ma-listing__body">
        <div className="ma-row" style={{ marginBottom: 2 }}>
          <span className="ma-price">{money(listing.monthlyPrice)} <small>pcm</small></span>
          <span className="ma-ago">{ago(listing.publishedAt)}</span>
        </div>
        <div className="ma-facts">{facts(listing)}</div>
        <div className="ma-address">{listing.address}</div>
        <div className="ma-meta">
          <span>{listing.postcode}</span>
          <span>{sourcesLabel(listing.sources)}</span>
        </div>
      </div>
    </button>
  );
}
